import { render, staticRenderFns } from "./OrdersManageView.vue?vue&type=template&id=61c63d12&"
import script from "./OrdersManageView.vue?vue&type=script&lang=js&"
export * from "./OrdersManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports